// Sort array by field
export function sortBy(array, field) {
  return array.sort((a, b) => (a[field] > b[field] ? 1 : -1));
}
